// R-C9: before archiving, the person sees what is linked to the records — the links and the history stay, the records come back from the archive.

import type { Id, RecordObj } from '@confdeck/core-shared';
import { archiveRecords, restoreRecords } from '../sync/mutations.ts';
import { useMeta, useSync } from '../sync/react.tsx';
import { Button, Dialog, useToast } from '../ui/primitives.tsx';
import s from '../team/team.module.css';

/** Linked live records of the chosen ones, counted by the field they are linked through («Билеты — 3»). */
function linkedSummary(client: ReturnType<typeof useSync>, meta: ReturnType<typeof useMeta>, ids: Id[]): { name: string; n: number }[] {
  const out = new Map<string, number>();
  for (const id of ids) {
    const rec = client.store.get(id) as RecordObj | undefined;
    if (!rec || rec.kind !== 'record') continue;
    for (const f of meta.fields(rec.typeId)) {
      if (f.fieldType !== 'relation' || f.archivedAt) continue;
      const n = client.store.linked(rec, f).filter((x) => { const r = client.store.get(x) as RecordObj | undefined; return r && !r.archivedAt; }).length;
      if (n) out.set(f.name, (out.get(f.name) ?? 0) + n);
    }
  }
  return [...out].map(([name, n]) => ({ name, n })).sort((a, b) => b.n - a.n);
}

export function ArchiveConfirm({ ids, title, onClose, onDone }: { ids: Id[]; title: string; onClose: () => void; onDone?: () => void }) {
  const client = useSync();
  const meta = useMeta();
  const toast = useToast();
  const linked = linkedSummary(client, meta, ids);
  const go = () => {
    archiveRecords(client, ids);
    onDone?.();
    onClose();
    toast({ kind: 'info', text: `${title} — в архиве`, action: { label: 'Вернуть', run: () => restoreRecords(client, ids) } });
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()} label="В архив">
      <div className={s.dialog}>
        <h2 className={s.dialogTitle}>В архив: {title}</h2>
        {linked.length
          ? <><p className={s.help}>С {ids.length > 1 ? 'этими записями' : 'этой записью'} связано:</p><ul className={s.help}>{linked.map((x) => <li key={x.name}>{x.name} — {x.n}</li>)}</ul>
            <p className={s.help}>Связанные записи останутся на месте, связи и история сохранятся. Вернуть можно из архива.</p></>
          : <p className={s.help}>Связанных записей нет. Вернуть можно из архива.</p>}
        <div className={s.actions}><span className={s.spacer} /><Button onClick={onClose}>Отмена</Button><Button variant="danger" onClick={go}>В архив</Button></div>
      </div>
    </Dialog>
  );
}
